/**
 * لیست پیش‌فرض و جامع رشته‌های ورزشی برای اطمینان از نمایش کامل در صورت عدم دریافت از سرور
 */
export const DEFAULT_SPORTS_FALLBACK = [
    { Id: "sport_pool", Name: "استخر، سونا و جکوزی" },
    { Id: "sport_swimming", Name: "شنا و تفریحات آبی" },
    { Id: "sport_bodybuilding", Name: "بدنسازی و پرورش اندام" },
    { Id: "sport_futsal", Name: "فوتسال" },
    { Id: "sport_football", Name: "فوتبال و چمن مصنوعی" },
    { Id: "sport_padel", Name: "پدل" },
    { Id: "sport_tennis", Name: "تنیس خاکی و سالنی" },
    { Id: "sport_crossfit", Name: "کراس‌فیت (CrossFit)" },
    { Id: "sport_trx", Name: "تی‌آرایکس (TRX)" },
    { Id: "sport_pilates", Name: "پیلاتس" },
    { Id: "sport_yoga", Name: "یوگا و مدیتیشن" },
    { Id: "sport_billiards", Name: "بیلیارد و اسنوکر" },
    { Id: "sport_bowling", Name: "بولینگ" },
    { Id: "sport_rockclimbing", Name: "صخره‌نوردی و بولدرینگ" },
    { Id: "sport_squash", Name: "اسکواش" },
    { Id: "sport_paintball", Name: "پینت‌بال" },
    { Id: "sport_shooting", Name: "تیراندازی (اهداف پروازی / تپانچه)" },
    { Id: "sport_horse", Name: "سوارکاری" },
    { Id: "sport_ski", Name: "اسکی و اسنوبورد" },
    { Id: "sport_skating", Name: "اسکیت و پاتیناژ" },
    { Id: "sport_boxing", Name: "بوکس و کیک‌بوکسینگ" },
    { Id: "sport_martial", Name: "هنرهای رزمی (کاراته، تکواندو، جودو)" },
    { Id: "sport_tabletennis", Name: "پینگ‌پنگ (تنیس روی میز)" },
    { Id: "sport_badminton", Name: "بدمینتون" },
    { Id: "sport_volleyball", Name: "والیبال" },
    { Id: "sport_basketball", Name: "بسکتبال" },
    { Id: "sport_gymnastics", Name: "ژیمناستیک" },
    { Id: "sport_karting", Name: "کارتینگ و موتوراسپورت" },
    { Id: "sport_massage", Name: "ماساژ و آب‌درمانی" },
    { Id: "sport_waterpolo", Name: "واترپلو و غواصی" },
    { Id: "sport_aerobics", Name: "ایروبیک و زومبا" },
    { Id: "sport_darts", Name: "دارت و ورزش‌های تفریحی" },
];

/**
 * ادغام و یکپارچه‌سازی لیست ورزش‌های سرور با ورزش‌های پیش‌فرض
 */
export function getUnifiedSportsList(apiSports = []) {
    const rawList = Array.isArray(apiSports)
        ? apiSports
        : (apiSports?.content || apiSports?.Data || []);

    const normalizedApi = (Array.isArray(rawList) ? rawList : []).map((s, idx) => ({
        Id: String(s.Id ?? s.id ?? s.sportId ?? `api_${idx}`),
        Name: String(s.Name ?? s.name ?? s.Title ?? s.title ?? `ورزش ${idx + 1}`).trim(),
        ...s,
    }));

    const map = new Map();

    // 1. اضافه کردن همه موارد برگشتی از API
    normalizedApi.forEach(sport => {
        if (sport.Name) {
            map.set(sport.Name.toLowerCase(), sport);
        }
    });

    // 2. اضافه کردن ورزش‌های استاندارد در صورتی که در سرور نباشند
    DEFAULT_SPORTS_FALLBACK.forEach(fb => {
        const key = fb.Name.toLowerCase();
        const existing = map.get(key);
        if (!existing) {
            const isCovered = Array.from(map.keys()).some(k =>
                k === key || (k.length > 3 && (k.includes(key) || key.includes(k)))
            );
            if (!isCovered) {
                map.set(key, fb);
            }
        }
    });

    return Array.from(map.values()).sort((a, b) => a.Name.localeCompare(b.Name, 'fa'));
}
